module.exports = __webpack_public_path__ + "img/男籃、女籃.97f849ff.jpg";